import React from 'react'

const SvgCheckboxDisabledSelected = ({ title, ...props }) => (
  <svg width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    {title ? <title>{title}</title> : null}
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group">
        <rect
          id="Rectangle-Copy-2"
          strokeOpacity="0.5"
          stroke="#9C9C9C"
          fill="#F2F2F2"
          x="0.5"
          y="0.5"
          width="15"
          height="15"
          rx="2"
        />
        <path
          d="M10.8798175,4.37613375 C11.3754242,3.86350618 12.1667867,3.87649264 12.6473751,4.40513983 C13.1279635,4.93378701 13.1157887,5.77790699 12.6201819,6.29053456 L7.46393234,11.6238672 C6.97907368,12.1253776 6.20842656,12.1253776 5.7235679,11.6238672 L3.3798181,9.19962511 C2.88421134,8.68699754 2.87203654,7.84287756 3.35262491,7.31423037 C3.83321328,6.78558319 4.62457579,6.77259673 5.12018254,7.2852243 L6.59375012,8.80939919 L10.8798175,4.37613375 Z"
          id="Path"
          fillOpacity="0.5"
          fill="#9C9C9C"
        />
      </g>
    </g>
  </svg>
)

export default SvgCheckboxDisabledSelected
